<template>
  <el-form
    label-width="160px"
    :inline="true"
    :model="form"
    class="demo-form-inline"
  >
    <el-form-item label="标题" required>
      <el-input v-model="form.title" clearable />
    </el-form-item>

    <el-form-item label="拼团分类" prop="class_id">
      <el-select v-model="form.class_id" placeholder="拼团分类" clearable>
        <el-option
          v-for="item in typesEnum"
          :label="item.title"
          :key="item.title"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="商品" prop="good_id">
      <el-select
        v-model="form.good_id"
        placeholder="商品"
        clearable
        @change="onGoodChange"
      >
        <el-option
          v-for="item in goodsList"
          :label="item.title"
          :key="item.title"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      label="商品图片"
      prop="good_img"
      :rules="[{ required: true, message: '请上传图片' }]"
    >
      <el-upload
        class="upload-demo"
        style="width: 114px"
        :show-file-list="false"
        drag
        :http-request="customUpload"
        :multiple="false"
        accept="image/*"
      >
        <img
          v-if="form.good_img"
          :src="previewImg(form.good_img)"
          width="100%"
          class="avatar"
        />
        <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
      </el-upload>
    </el-form-item>
    <el-form-item label="是否推荐" required>
      <el-select v-model="form.is_recommend" placeholder="是否推荐" clearable>
        <el-option
          v-for="item in booleanEnums"
          :label="item.label"
          :key="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="排序" required>
      <el-input type="number" v-model="form.sort" clearable />
    </el-form-item>
    <el-form-item label="拼团价格" required>
      <el-input v-model="form.price" clearable />
    </el-form-item>
    <el-form-item label="拼团人数" required>
      <el-input v-model="form.people" clearable />
    </el-form-item>
    <el-form-item label="每小时增加人数" required>
      <el-input v-model="form.people_add" clearable />
    </el-form-item>
    <el-form-item label="拼团失败返现" required>
      <el-input v-model="form.fail_money" clearable />
    </el-form-item>
    <el-form-item label="拼团失败返积分" required>
      <el-input v-model="form.fail_points" clearable />
    </el-form-item>
    <el-form-item label="限购次数" required>
      <el-input v-model="form.limit" clearable />
    </el-form-item>
    <el-form-item label="会员等级" required>
      <el-input v-model="form.level" clearable />
    </el-form-item>
    <el-form-item label="需要投资金额" required>
      <el-input v-model="form.item_money" clearable />
    </el-form-item>
    <el-form-item label="活跃度" required>
      <el-input v-model="form.activity_val" clearable />
    </el-form-item>
    <el-form-item label="显示状态" required>
      <el-select v-model="form.status" placeholder="显示状态" clearable>
        <el-option
          v-for="item in showStatusEnums"
          :label="item.label"
          :key="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="开奖时间" required>
      <el-date-picker
        v-model="form.next_time"
        type="datetime"
        value-format="YYYY-MM-DD HH:mm"
        placeholder="开奖时间"
        style="width: 100%"
      />
    </el-form-item>
    <el-form-item label="开奖周期（天）" required>
      <el-input v-model="form.cycle" clearable />
    </el-form-item>
    <el-form-item label="福利说明" required>
      <el-input v-model="form.desc" clearable />
    </el-form-item>
  </el-form>
</template>

<script setup>
import { booleanEnums, showStatusEnums } from "@/config/enums";
import {
  nextTick,
  ref,
  onMounted,
  getCurrentInstance,
} from "vue";
import { ElMessage } from "element-plus";

const form = ref({
  title: "",
  class_id: "",
  is_recommend: "",
  sort: "",
  price: "",
  people: "",
  fail_points: "",
  people_add: "",
  fail_money: "",
  limit: "",
  level: "",
  item_money: "",
  activity_val: 0,
  status: "",
  next_time: "",
  cycle: "",
  desc: "",
  good_id: "",
  good_img: "",
});
const props = defineProps(["item"]);

const { proxy } = getCurrentInstance();

onMounted(() => {
  nextTick(() => {
    if (props.item && typeof props.item === "object") {
      Object.assign(form.value, props.item);
    }
  });
  getTYpesEnum();
  getGoodsList();
});

const typesEnum = ref([]);

const getTYpesEnum = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/GroupBuy/getGroupBuyClassLists",
  });

  if (res.code == 0) {
    typesEnum.value = res.data.data;
  }
};

const goodsList = ref([]);

const getGoodsList = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Goods/getGoodsLists",
    params: {
      page: 1,
      limit: 999,
    },
  });

  if (res.code == 0) {
    goodsList.value = res.data.data;
  }
};

const previewImg = (url) => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return (proxy.IMG_BASE_URL || "") + url;
};

const onGoodChange = (goodId) => {
  const good = goodsList.value.find((item) => item.id === goodId);
  if (good?.img) {
    form.value.good_img = good.img;
  }
};

/** 走 axios 同源代理上传，避免 el-upload 直连 HTTPS 域名 */
const customUpload = async (options) => {
  const data = new FormData();
  data.append("file", options.file);
  try {
    const res = await proxy.$http(
      {
        method: "post",
        url: "/index/upload",
        data,
      },
      { error_message_show: true }
    );
    if (res && res.code == 0 && res.data?.url) {
      form.value.good_img = res.data.url;
      options.onSuccess?.(res);
      ElMessage.success("上传成功");
    } else {
      const msg = res?.msg || res?.message || "上传失败";
      ElMessage.error(msg);
      options.onError?.(new Error(msg));
    }
  } catch (e) {
    ElMessage.error("上传失败，请稍后重试");
    options.onError?.(e);
  }
};

defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}

.demo-form-inline .el-input {
  --el-input-width: 260px;
}

.demo-form-inline .el-select {
  --el-select-width: 260px;
}

/deep/ .el-radio-group {
  width: 260px;
}

.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}

/deep/ .el-form-item {
  align-items: flex-start;
}

.upload-demo :deep(.el-upload-dragger) {
  width: 114px;
  height: 114px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  display: block;
  width: 100%;
  height: 114px;
  object-fit: cover;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
</style>
